export enum FicaStatus {
    NotSent = 1,
    Pending = 2,
    Rejected = 3,
    Approved = 4
}